/**
 * 江城记忆长卷的小卷轴图标（导航栏入口 & 开屏收起飞行令牌共用）。
 * 24x24 描边风格，与导航栏分享 / 登录图标保持一致。
 */
export const HISTORY_SCROLL_ICON_SVG = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="2.8" y="5.5" width="3" height="13" rx="1.5"/><rect x="18.2" y="5.5" width="3" height="13" rx="1.5"/><path d="M5.8 8.4c3.2-1.1 9.2 1.1 12.4 0"/><path d="M5.8 15.6c3.2 1.1 9.2-1.1 12.4 0"/><path d="M8.7 10.9h6.6"/><path d="M8.7 13.3h4.2"/></svg>`;
